// extracted by mini-css-extract-plugin
export default {"partnerCon":"Partner_partnerCon__tOvBX","partnerBox":"Partner_partnerBox__LiqHT","scroll":"Partner_scroll__hDrUD","img":"Partner_img__-zyC3"};